<app-page-header
  title="Criar evento"
  subtitle="Antes de criar um evento, é necessário
	atualizar o cadastro para produtor"
  [headerFlexWrap]="false">
  <div class="container-button-close">
    <button type="button" class="btn-close" aria-label="Close" [mat-dialog-close]="false"></button>
  </div>
</app-page-header>

<div class="form-section">
  <div>
    <mat-checkbox color="primary" [formControl]="keepAsIndividualControl">
      Manter cadastro como Pessoa Física
    </mat-checkbox>
  </div>

  <mat-divider class="mb-2 mt-1" />

  @if (keepAsIndividualControl.value) {
    <form [formGroup]="individualForm" novalidate>
      <div class="mb-3">
        <label for="name" class="form-label">Nome Completo</label>
        <input
          type="text"
          class="form-control"
          id="name"
          placeholder="Nome e Sobrenome"
          formControlName="name"
          [ngClass]="{
            'is-invalid': individualForm.controls.name.invalid && individualForm.controls.name.touched,
          }" />
        @if (individualForm.controls.name.invalid && individualForm.controls.name.touched) {
          <div class="invalid-feedback">
            @if (individualForm.controls.name.errors?.["required"]) {
              <span> Campo nome completo esta vazio </span>
            }
            @if (individualForm.controls.name.errors?.["invalidName"]) {
              <span> Você deve inserir nome e sobrenome </span>
            }
            @if (individualForm.controls.name.errors?.["minlength"]) {
              <span> Nome muito pequeno </span>
            }
          </div>
        }
      </div>

      <div class="mb-3">
        <label for="phone" class="form-label">Celular</label>
        <div class="form-group form-phone">
          <app-ddi-select formControlName="ddi"></app-ddi-select>
          <input
            type="phone"
            class="form-control"
            id="phone"
            formControlName="phone"
            inputmode="numeric"
            placeholder="(00) 00000-0000"
            [mask]="individualForm.controls.ddi.value === '+55' ? '(00) 00000-0000' : ''"
            [ngClass]="{
              'is-invalid': individualForm.controls.phone.invalid && individualForm.controls.phone.touched,
            }" />
          @if (individualForm.controls.phone.invalid && individualForm.controls.phone.touched) {
            <div class="invalid-feedback">
              @if (individualForm.controls.phone.errors?.["required"]) {
                <span> Campo Telefone não pode estar vazio </span>
              }
              @if (individualForm.controls.phone.errors?.["invalidPhoneNumber"]) {
                <span> O campo telefone deve conter somente numeros </span>
              }
            </div>
          }
        </div>
      </div>

      <div class="mb-3">
        <label for="cpf" class="form-label">CPF</label>
        <input
          type="text"
          class="form-control"
          id="cpf"
          placeholder="CPF"
          formControlName="cpf"
          mask="000.000.000-00"
          [ngClass]="{
            'is-invalid': individualForm.controls.cpf.invalid && individualForm.controls.cpf.touched,
          }" />
        @if (individualForm.controls.cpf.invalid && individualForm.controls.cpf.touched) {
          <div class="invalid-feedback">
            <!-- Mensagem de erro caso o campo esteja vazio -->
            @if (individualForm.controls.cpf.errors?.["required"]) {
              <span> Campo CPF está vazio </span>
            }
            @if (individualForm.controls.cpf.errors?.["cpfInvalid"]) {
              <span> CPF inválido </span>
            }
          </div>
        }
      </div>
    </form>
  } @else {
    <form [formGroup]="companyForm" novalidate>
      <div class="mb-3">
        <label for="name" class="form-label">CNPJ</label>
        <input
          type="text"
          class="form-control"
          id="cnpj"
          mask="00.000.000/0000-00"
          [dropSpecialCharacters]="false"
          placeholder="00.000.000/0000-00"
          formControlName="cnpj"
          [ngClass]="{
            'is-invalid': companyForm.controls.cnpj.invalid && companyForm.controls.cnpj.touched,
          }" />
        @if (companyForm.controls.cnpj.invalid && companyForm.controls.cnpj.touched) {
          <div class="invalid-feedback">
            @if (companyForm.controls.cnpj.errors?.["required"]) {
              <span> Campo obrigatório </span>
            }
            @if (companyForm.controls.cnpj.errors?.["cnpjInvalid"]) {
              <span> CNPJ inválido </span>
            }
          </div>
        }
      </div>

      <div class="mb-3">
        <label for="name" class="form-label">Razão Social</label>
        <input
          type="text"
          class="form-control"
          id="companyName"
          placeholder="Razão Social"
          formControlName="companyName"
          [ngClass]="{
            'is-invalid': companyForm.controls.companyName.invalid && companyForm.controls.companyName.touched,
          }" />
        @if (companyForm.controls.companyName.invalid && companyForm.controls.companyName.touched) {
          <div class="invalid-feedback">
            @if (companyForm.controls.companyName.errors?.["required"]) {
              <span> Campo obrigatório </span>
            }
          </div>
        }
      </div>
    </form>
  }

  <mat-divider class="mb-2 mt-1" />

  <div>
    <mat-checkbox
      color="primary"
      [formControl]="acceptUserTerms"
      [ngClass]="{
        'is-invalid': acceptUserTerms.invalid && acceptUserTerms.touched,
      }">
      Concordo com os
      <button mat-button color="primary" (click)="openContractDialog()">termos de uso</button>
    </mat-checkbox>
    @if (acceptUserTerms?.invalid && acceptUserTerms?.touched) {
      <div class="invalid-feedback">É obrigatório aceitar os termos</div>
    }
  </div>

  <div class="actions">
    <app-button (click)="handleFormSubmit()" styleType="secondary">Atualizar meus dados</app-button>
    <app-button [mat-dialog-close]="false" styleType="outlined">Cancelar</app-button>
  </div>
</div>
